const s = {
  container: {
    display: 'flex',
    flexDirection: 'column',
    height: '100%',
    backgroundColor: 'var(--agx-bg)',
    overflow: 'hidden',
  },
  tabsBar: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    backgroundColor: 'var(--agx-surface)',
    borderBottom: '1px solid var(--agx-border)',
    padding: '0 12px',
    flexShrink: 0,
    flexWrap: 'wrap',
    gap: '4px',
    minHeight: '48px',
  },
  tabGroup: { display: 'flex', gap: '0' },
  tabBtn: {
    padding: '14px 16px',
    borderWidth: '0 0 2px 0',
    borderStyle: 'solid',
    borderColor: 'transparent',
    background: 'transparent',
    fontSize: '13px',
    fontWeight: 500,
    cursor: 'pointer',
    color: 'var(--agx-muted)',
    display: 'flex',
    alignItems: 'center',
    gap: '8px',
    transition: 'all 0.2s',
    whiteSpace: 'nowrap',
  },
  tabBtnActive: {
    color: 'var(--agx-pri2)',
    borderColor: 'var(--agx-pri2)',
    fontWeight: 600,
  },
  tabBtnHidden: {},
  tabBadge: {
    fontSize: '10px',
    fontWeight: 700,
    color: '#fff',
    backgroundColor: '#ea4335',
    minWidth: '18px',
    height: '18px',
    borderRadius: '9px',
    display: 'inline-flex',
    alignItems: 'center',
    justifyContent: 'center',
    padding: '0 5px',
    lineHeight: 1,
  },
  sedeFilterWrap: {
    display: 'flex',
    alignItems: 'center',
    gap: '8px',
    padding: '8px 0',
  },
  sedeSelect: {
    padding: '6px 10px',
    borderRadius: '8px',
    border: '1px solid var(--agx-border)',
    fontSize: '12px',
    fontFamily: 'inherit',
    outline: 'none',
    backgroundColor: 'var(--agx-surface)',
    color: 'var(--agx-text)',
    minWidth: '140px',
    maxWidth: '200px',
  },
  mainArea: {
    display: 'flex',
    flex: 1,
    overflow: 'hidden',
    minHeight: 0,
  },
  leftPanel: {
    width: '320px',
    minWidth: '280px',
    maxWidth: '380px',
    borderRight: '1px solid var(--agx-border)',
    backgroundColor: 'var(--agx-surface)',
    display: 'flex',
    flexDirection: 'column',
    flexShrink: 0,
    height: '100%',
    overflow: 'hidden',
  },
  rightPanel: {
    flex: 1,
    display: 'flex',
    flexDirection: 'column',
    backgroundColor: 'var(--agx-bg2)',
    height: '100%',
    overflow: 'hidden',
    minWidth: 0,
  },
  rightPanelWhite: {
    flex: 1,
    display: 'flex',
    flexDirection: 'column',
    backgroundColor: 'var(--agx-surface)',
    height: '100%',
    overflow: 'hidden',
    minWidth: 0,
  },
  fullPanel: {
    flex: 1,
    display: 'flex',
    flexDirection: 'column',
    height: '100%',
    overflow: 'hidden',
    minWidth: 0,
  },
  pedidoDetailOverlay: {
    width: '420px',
    minWidth: '360px',
    maxWidth: '500px',
    backgroundColor: 'var(--agx-surface)',
    borderLeft: '1px solid var(--agx-border)',
    display: 'flex',
    flexDirection: 'column',
    flexShrink: 0,
    height: '100%',
    overflow: 'auto',
    boxShadow: '-4px 0 24px rgba(11,26,74,0.10)',
  },
  searchBox: {
    display: 'flex',
    alignItems: 'center',
    padding: '10px 14px',
    borderBottom: '1px solid var(--agx-header-border)',
    gap: '8px',
  },
  chatList: {
    flex: 1,
    overflowY: 'auto',
    padding: '4px 0',
  },
  chatItem: {
    display: 'flex',
    alignItems: 'center',
    padding: '12px 14px',
    cursor: 'pointer',
    borderBottom: '1px solid var(--agx-border)',
    transition: 'background 0.15s',
    gap: '10px',
  },
  chatItemActive: { backgroundColor: 'var(--agx-blue-bg)' },
  chatItemInfo: {
    flex: 1,
    minWidth: 0,
    display: 'flex',
    flexDirection: 'column',
    gap: '3px',
  },
  chatItemTop: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
  },
  chatItemName: { fontSize: '14px', fontWeight: 600, color: 'var(--agx-text)' },
  chatItemTime: { fontSize: '11px', color: 'var(--agx-muted)' },
  chatItemPreview: {
    fontSize: '12px',
    color: 'var(--agx-muted)',
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
  },
  noLeidosBadge: {
    backgroundColor: 'var(--agx-pri2)',
    color: '#fff',
    fontSize: '11px',
    fontWeight: 600,
    padding: '2px 7px',
    borderRadius: '10px',
    minWidth: '20px',
    textAlign: 'center',
    flexShrink: 0,
  },
  emptyState: {
    textAlign: 'center',
    color: 'var(--agx-faint)',
    fontSize: '13px',
    padding: '40px 20px',
  },
  tomarChatBtn: {
    padding: '12px 20px',
    backgroundColor: 'var(--agx-green)',
    color: '#fff',
    border: 'none',
    fontSize: '14px',
    fontWeight: 600,
    cursor: 'pointer',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    gap: '8px',
    marginTop: 'auto',
    flexShrink: 0,
  },
  kanbanContainer: {
    flex: 1,
    display: 'flex',
    gap: '12px',
    padding: '16px',
    overflowX: 'auto',
    overflowY: 'hidden',
    minHeight: 0,
    cursor: 'grab',
    userSelect: 'none',
    WebkitOverflowScrolling: 'touch',
  },
  kanbanDragging: {
    cursor: 'grabbing',
  },
  faseColumna: {
    minWidth: '260px',
    maxWidth: '300px',
    backgroundColor: 'var(--agx-bg)',
    borderRadius: '12px',
    display: 'flex',
    flexDirection: 'column',
    flexShrink: 0,
  },
  faseHeader: {
    padding: '12px 14px',
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    borderBottomWidth: '2px',
    borderBottomStyle: 'solid',
    borderBottomColor: 'transparent',
    flexShrink: 0,
    borderRadius: '12px 12px 0 0',
  },
  faseTitle: { fontSize: '13px', fontWeight: 600, textTransform: 'capitalize' },
  faseCount: {
    fontSize: '11px',
    backgroundColor: 'rgba(0,0,0,0.08)',
    padding: '2px 8px',
    borderRadius: '10px',
    fontWeight: 600,
  },
  faseCards: {
    flex: 1,
    overflowY: 'auto',
    padding: '8px',
    display: 'flex',
    flexDirection: 'column',
    gap: '8px',
  },
  pedidoCard: {
    backgroundColor: 'var(--agx-surface)',
    borderRadius: '10px',
    padding: '12px',
    boxShadow: '0 1px 3px rgba(0,0,0,0.06)',
    cursor: 'pointer',
    borderWidth: '1px',
    borderStyle: 'solid',
    borderColor: 'var(--agx-border)',
    transition: 'box-shadow 0.2s',
    display: 'flex',
    flexDirection: 'column',
    gap: '6px',
  },
  pedidoCardTop: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'flex-start',
  },
  pedidoCardId: { fontSize: '13px', fontWeight: 700, color: 'var(--agx-pri)' },
  pedidoCardTotal: { fontSize: '13px', fontWeight: 700, color: 'var(--agx-pri2)' },
  pedidoCardCliente: { fontSize: '12px', color: 'var(--agx-text)', fontWeight: 500 },
  pedidoCardSede: {
    fontSize: '11px',
    color: 'var(--agx-faint)',
    display: 'flex',
    alignItems: 'center',
    gap: '3px',
  },
  pedidoCardMeta: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    fontSize: '11px',
    color: 'var(--agx-muted)',
  },
  pedidoCardItems: { fontSize: '11px', color: 'var(--agx-muted)' },
  pedidoCardTime: {
    fontSize: '11px',
    color: 'var(--agx-faint)',
    display: 'flex',
    alignItems: 'center',
    gap: '4px',
  },
  pedidoCardConfirmacionBadge: {
    fontSize: '10px',
    fontWeight: 600,
    color: 'var(--agx-amber)',
    backgroundColor: 'var(--agx-amber-bg)',
    padding: '2px 6px',
    borderRadius: '6px',
    display: 'inline-flex',
    alignItems: 'center',
    gap: '3px',
    marginTop: '2px',
  },
  noSelection: {
    flex: 1,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    color: 'var(--agx-faint)',
    fontSize: '14px',
    flexDirection: 'column',
    gap: '8px',
  },
  detalleBackBtn: {
    padding: '10px 14px',
    background: 'none',
    border: 'none',
    cursor: 'pointer',
    color: 'var(--agx-pri2)',
    fontSize: '13px',
    fontWeight: 600,
    display: 'flex',
    alignItems: 'center',
    gap: '6px',
    borderBottom: '1px solid var(--agx-header-border)',
    flexShrink: 0,
  },
  mobileBack: {
    display: 'flex',
    padding: '10px 14px',
    gap: '8px',
    borderBottom: '1px solid var(--agx-border)',
    alignItems: 'center',
    flexShrink: 0,
  },
  mobileList: { width: '100%', height: '100%', display: 'flex', flexDirection: 'column' },
  mobileDetail: { width: '100%', height: '100%', display: 'flex', flexDirection: 'column' },
  infoPanelCloseBtn: {
    padding: '16px',
    background: 'none',
    border: 'none',
    cursor: 'pointer',
    color: 'var(--agx-muted)',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'flex-end',
    borderBottom: '1px solid var(--agx-header-border)',
    flexShrink: 0,
  },
  // Nuevos estilos para PedidosPanel
  pedidosContainer: {
    flex: 1,
    display: 'flex',
    flexDirection: 'column',
    height: '100%',
    overflow: 'hidden',
    minWidth: 0,
  },
  pedidosHeader: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    padding: '10px 16px',
    backgroundColor: 'var(--agx-surface)',
    borderBottom: '1px solid var(--agx-border)',
    flexShrink: 0,
    flexWrap: 'wrap',
    gap: '8px',
  },
  pedidosHeaderLeft: {
    display: 'flex',
    alignItems: 'center',
    gap: '12px',
  },
  pedidosHeaderRight: {
    display: 'flex',
    alignItems: 'center',
    gap: '10px',
  },
  pedidosTabBtn: {
    padding: '8px 18px',
    borderRadius: '20px',
    border: '1px solid var(--agx-border)',
    backgroundColor: 'var(--agx-surface)',
    fontSize: '13px',
    fontWeight: 500,
    cursor: 'pointer',
    color: 'var(--agx-muted)',
    transition: 'all 0.2s',
    whiteSpace: 'nowrap',
  },
  pedidosTabBtnActive: {
    backgroundColor: 'var(--agx-pri2)',
    color: '#fff',
    borderColor: 'var(--agx-pri2)',
    fontWeight: 600,
  },
  pedidosCount: {
    fontSize: '12px',
    color: 'var(--agx-faint)',
    fontWeight: 400,
  },
  // Finalizados
  finalizadosContainer: {
    flex: 1,
    display: 'flex',
    flexDirection: 'column',
    overflow: 'hidden',
    backgroundColor: 'var(--agx-surface)',
  },
  finalizadosFilters: {
    display: 'flex',
    alignItems: 'center',
    gap: '10px',
    padding: '10px 16px',
    borderBottom: '1px solid var(--agx-border)',
    flexShrink: 0,
    flexWrap: 'wrap',
  },
  finalizadosFilterInput: {
    padding: '6px 10px',
    border: '1px solid var(--agx-border)',
    borderRadius: '8px',
    fontSize: '12px',
    fontFamily: 'inherit',
    outline: 'none',
    color: 'var(--agx-text)',
  },
  finalizadosFilterLabel: {
    fontSize: '11px',
    color: 'var(--agx-muted)',
    fontWeight: 500,
  },
  finalizadosTable: {
    flex: 1,
    overflowY: 'auto',
    overflowX: 'auto',
  },
  finalizadosTableHead: {
    position: 'sticky',
    top: 0,
    backgroundColor: 'var(--agx-bg)',
    zIndex: 2,
    display: 'flex',
    fontSize: '11px',
    fontWeight: 600,
    color: 'var(--agx-muted)',
    borderBottom: '1px solid var(--agx-border)',
    minWidth: '700px',
  },
  finalizadosTableRow: {
    display: 'flex',
    fontSize: '12px',
    borderBottom: '1px solid var(--agx-header-border)',
    alignItems: 'center',
    cursor: 'pointer',
    transition: 'background 0.15s',
    minWidth: '700px',
  },
  finalizadosCell: {
    padding: '10px 12px',
    flexShrink: 0,
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
  },
  finalizadosBadge: {
    padding: '2px 8px',
    borderRadius: '8px',
    fontSize: '10px',
    fontWeight: 600,
    whiteSpace: 'nowrap',
  },
  dashBadge: {
    display: 'inline-flex',
    alignItems: 'center',
    gap: '4px',
    padding: '4px 10px',
    borderRadius: '14px',
    fontSize: '11px',
    fontWeight: 600,
    whiteSpace: 'nowrap',
  },
  dashContainer: {
    display: 'flex',
    gap: '6px',
    padding: '6px 16px',
    flexWrap: 'wrap',
    backgroundColor: 'var(--agx-surface)',
    borderBottom: '1px solid var(--agx-border)',
    flexShrink: 0,
    overflowX: 'auto',
    whiteSpace: 'nowrap',
  },
};

export default s;
